import { clsx } from 'clsx'
import { IconButton } from 'component/Button/IconButton'
import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { MainIcon } from 'page/MainIcon/MainIcon'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { postMessage } from 'util/message'
import css from './MiniBar.module.scss'

const frame = (element: HTMLDivElement | null) => {
  const width = element?.clientWidth
  postMessage('frame', { width })
}

export const MiniBar = observer(() => {
  const { error, loader, count } = store

  const onMax = useLatestCallback(() => {
    store.state = 'max'
  })

  const onRef = useLatestCallback((element: HTMLDivElement | null) => {
    if (element) {
      const ro = new ResizeObserver(() => frame(element))
      ro.observe(element)
    }
    frame(element)
  })

  return (
    <Space ref={onRef} className={css.root} onClick={onMax}>
      <Space wide gap={4}>
        <Space>
          {!error && <Space gap={16} opposite oh>
            <Space gap={8} oh>
              <Typo className={css.color} size={13} primary medium ellipsis>
                {store.title}
              </Typo>
            </Space>
          </Space>}
          {error && <Typo size={16} bold error ellipsis>{i18n('error.ErrorMini')}</Typo>}
          <div className={css.div} />
          <Space width={24} height={24}>
            <Space className={css.icon}>
              <MainIcon size={16} />
            </Space>
            {count > 0 && <Space className={clsx(css.count, opt.tsum && css.tsum)}>
              <Typo size={8} one medium>
                {count}
              </Typo>
            </Space>}
          </Space>
        </Space>
        <Space>
          {error && <Space width={32} center>
            <Icon size={20} name="error" error />
          </Space>}
          {!error && loader && <Space width={32} center>
            <Loader />
          </Space>}
          <IconButton link action={onMax} className={css.color}>
            <Icon name="expand_content" size={24} />
          </IconButton>
        </Space>
      </Space>
    </Space>
  )
})
